import * as server from '../../../Axios'

export const getSolicitudPend = async q => {
  return await server
    .getSolicitudPend(q)
    .then(response => ({ data: response.data }))
    .catch(error => ({ error: error }))
}